<template>
  <v-container fluid class="px-0">
    <v-expansion-panels v-model="searchPanel" class="mb-0" v-if="!loadDefault">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <v-row no-gutters>
            <v-col cols="4">
              Paieška
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <form @keydown.enter.prevent="submit()">
            <v-row class="mb-3">
              <v-col cols="12" md="6">
                <el-text-field
                  label="Identifikavimo kodas (IDK)"
                  v-model="extraData.obj_identifikavimo_kodas"
                  idk
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-autocomplete
                  :items="objektasList"
                  itemvalue="value"
                  itemtext="text"
                  :multiple="false"
                  label="Objektas"
                  v-model="extraData.objektas"
                  @change="objektasChange()"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-autocomplete
                  :items="filteredPranesimasRusys"
                  itemvalue="value"
                  itemtext="text"
                  :multiple="true"
                  label="Pranešimo rūšis"
                  v-model="extraData.obj_tipas"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-autocomplete
                  :items="veiksmasList"
                  itemvalue="value"
                  itemtext="text"
                  :multiple="true"
                  label="Veiksmas"
                  :readonly="!enableVeiksmas"
                  v-model="extraData.veiksmas"
                  @change="veiksmasChange()"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-text-field
                  label="Dokumento numeris"
                  v-model="extraData.obj_dokumento_numeris"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-text-field
                  label="Duomenų teikėjas"
                  v-model="extraData.obj_duomenu_teikejas"
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-autocomplete
                  :items="busena_objektas"
                  itemvalue="value"
                  itemtext="text"
                  :multiple="true"
                  label="Būsena"
                  v-model="extraData.obj_busena"
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-date-picker
                  label="Būsenos data nuo"
                  v-model="extraData.obj_busenos_data_nuo"
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-date-picker
                  label="Būsenos data iki"
                  v-model="extraData.obj_busenos_data_iki"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-text-field
                  label="Šalis (pirma)"
                  v-model="extraData.obj_skolininko_pavadinimas"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-text-field
                  label="Šalies (pirmos) kodas"
                  v-model="extraData.obj_skolininko_kodas"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-text-field
                  label="Šalis (antra)"
                  v-model="extraData.obj_kreditoriaus_pavadinimas"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-text-field
                  label="Šalies (antros) kodas"
                  v-model="extraData.obj_kreditoriaus_kodas"
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-date-picker
                  label="Perdavimo registrui data nuo"
                  v-model="extraData.obj_perdavimo_data_nuo"
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-date-picker
                  label="Perdavimo registrui data iki"
                  v-model="extraData.obj_perdavimo_data_iki"
                />
              </v-col>
              <v-col cols="12" md="4"></v-col>
              <v-col cols="12" md="6">
                <el-autocomplete
                  :items="asmenys"
                  itemvalue="value"
                  itemtext="text"
                  :multiple="true"
                  label="Paskutinis veiksmus atlikęs asmuo"
                  v-model="extraData.obj_pateikes_asmuo"
                />
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="12">
                <el-button primary @click.native.stop="searchData()">
                  Ieškoti
                </el-button>
                <el-button @click.native="clearData()">
                  Išvalyti
                </el-button>
              </v-col>
            </v-row>
          </form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import objektasSearch from '../../mixins/objektasSearch'

export default {
  name: 'PranesimasPerduotiSearch',
  props: {
    loading: Boolean,
  },
  mixins: [objektasSearch],
  data: () => ({
    searchPanel: null,
    loadDefault: null,
    mainData: {},
    extraData: {
      objektas: null,
      veiksmas: [],
    },
    pranesimas_rusys: [],
    busena_objektas: [],
    asmenys: [],
  }),
  computed: {
    ...mapGetters(['searchParams', 'listInfo']),
    isExpanded() {
      return this.searchPanel === 0
    },
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loadDefault = true

      const data = {
        klasifikatoriai: ['perduoti_rusys', 'busena_objektas', 'asmenys'],
      }

      this.$axios
        .post(`klasifikatorius/list`, data)
        .then(res => {
          this.pranesimas_rusys = res.data.list.perduoti_rusys
          this.busena_objektas = res.data.list.busena_objektas
          this.asmenys = res.data.list.asmenys

          if (
            this.searchParams &&
            this.searchParams.route === this.$route.name
          ) {
            this.mainData = this.searchParams.mainData
            this.extraData = this.searchParams.extraData
            this.searchPanel = this.searchParams.isExpanded ? 0 : null
          }

          this.searchData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loadDefault = false
        })
    },
    searchData() {
      let searchData = {
        ...this.mainData,
        ...this.extraData,
      }

      if (this.$route.params.toList) {
        searchData = this.listInfo.search
      }

      this.$store.dispatch('searchParams', {
        route: this.$route.name,
        mainData: this.mainData,
        extraData: this.extraData,
        isExpanded: this.isExpanded,
      })

      this.$emit('search', searchData)
    },
    clearData() {
      this.mainData = {}
      this.extraData = {
        objektas: null,
        veiksmas: [],
      }
    },
    submit() {
      this.searchData()
    },
    clearRusis() {
      this.extraData.obj_tipas = []
    },
  },
}
</script>
